import { SubmittedFormModel } from "app/services/api/types/forms/models/SubmittedFormModel";
import { useMemo } from "react";
import { format } from "date-fns";
import { getFullName } from "ui/utils/nameUtil";

interface Props {
  form: SubmittedFormModel;
}
export function useAssessmentState({ form }: Props) {
  const createdAt = useMemo(() => {
    return format(new Date(form.created_at), "dd-MM-yyyy 'at' HH:mm");
  }, [form?.created_at]);

  const createdBy = useMemo(() => {
    return getFullName(form.user);
  }, [form?.user]);

  const signedOffAt = useMemo(() => {
    if (!form.signed_off_at) return null;
    return format(new Date(form.signed_off_at), "dd-MM-yyyy 'at' HH:mm");
  }, [form?.signed_off_at]);

  const signedOffBy = useMemo(() => {
    if (!form.signed_off_by) return null;
    return getFullName(form.signed_off_by);
  }, [form.signed_off_by]);

  const barthelScore = useMemo(() => {
    return form?.total_score;
  }, [form?.total_score]);

  const signedOffText = useMemo(
    () =>
      signedOffBy && signedOffAt
        ? `Signed Off by ${signedOffBy} on ${signedOffAt}`
        : null,
    [signedOffBy, signedOffAt],
  );

  const createdByText = useMemo(
    () =>
      createdBy && createdAt ? `Created by ${createdBy} on ${createdAt}` : null,
    [createdBy, createdAt],
  );
  return {
    createdByText,
    signedOffText,
    barthelScore,
  };
}
